{
    "FqoOd_cKGhduW-qTgn7xm": {
        "position": {
            "x": 22,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "FqoOd_cKGhduW-qTgn7xm"
    },
    "AspZtOuycnBrV-8oAaR1K": {
        "position": {
            "x": 7,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "AspZtOuycnBrV-8oAaR1K"
    },
    "pcdoLxE7AIXKO8oRZqaBu": {
        "position": {
            "x": 6,
            "y": 18,
            "z": 1
        },
        "templateKey": "jobs/gun",
        "jobKey": "gun",
        "affiliation": "neutral",
        "key": "pcdoLxE7AIXKO8oRZqaBu"
    },
    "EdFCKEHejvqgz_1m1nRHX": {
        "position": {
            "x": 7,
            "y": 17,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "neutral",
        "key": "EdFCKEHejvqgz_1m1nRHX"
    },
    "QA-yGxZPRsvcwTkrgcKMA": {
        "position": {
            "x": 8,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "QA-yGxZPRsvcwTkrgcKMA"
    },
    "mpwB209P7AR6OzI0vPt2g": {
        "position": {
            "x": 21,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/spear",
        "jobKey": "spear",
        "affiliation": "neutral",
        "key": "mpwB209P7AR6OzI0vPt2g"
    },
    "drx3AB7ZyCuYRQE5kuKNA": {
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "neutral",
        "key": "drx3AB7ZyCuYRQE5kuKNA"
    },
    "4fXzJFTAfvyEsPUJrVe9y": {
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/gun",
        "jobKey": "gun",
        "affiliation": "bad",
        "key": "4fXzJFTAfvyEsPUJrVe9y"
    }
}